// Minimal i18n helper for the landing bundle.
//
// Picks the dictionary from window.__culture (emitted by Index.cshtml from
// SeoLanguage.GetCurrent) and falls back to "uk".
//
// Usage:
//   import { t } from "./i18n/index.js";
//   t("hero.title")                  // -> "AI-комунікація..." (uk) / "AI communication..." (en)
//   t("cta.tryDays", { days: 14 })   // -> with placeholder interpolation: {days}
//
// Keys are dot-separated paths into nested dictionaries. Missing keys return
// the key string itself so omissions are visible during translation.

import { dict as uk } from "./uk.js";
import { dict as en } from "./en.js";

const DICTS = { uk, en };

export function currentCulture() {
  if (typeof window !== "undefined" && typeof window.__culture === "string") {
    const c = window.__culture.toLowerCase();
    if (c in DICTS) return c;
  }
  return "uk";
}

function lookup(dict, key) {
  let node = dict;
  for (const part of key.split(".")) {
    if (node == null || typeof node !== "object") return undefined;
    node = node[part];
  }
  return typeof node === "string" ? node : undefined;
}

function interpolate(template, vars) {
  if (!vars) return template;
  return template.replace(/\{(\w+)\}/g, (_, name) =>
    Object.prototype.hasOwnProperty.call(vars, name) ? String(vars[name]) : `{${name}}`
  );
}

export function t(key, vars) {
  const culture = currentCulture();
  const value = lookup(DICTS[culture], key) ?? lookup(DICTS.uk, key) ?? key;
  return interpolate(value, vars);
}

// Returns a localized list (array) from the dictionary. Missing keys yield [].
export function tList(key) {
  const culture = currentCulture();
  let node = DICTS[culture];
  for (const part of key.split(".")) {
    if (node == null || typeof node !== "object") {
      node = undefined;
      break;
    }
    node = node[part];
  }
  if (Array.isArray(node)) return node;

  // Fallback to UK if EN key is missing or not an array.
  let ukNode = DICTS.uk;
  for (const part of key.split(".")) {
    if (ukNode == null || typeof ukNode !== "object") return [];
    ukNode = ukNode[part];
  }
  return Array.isArray(ukNode) ? ukNode : [];
}
